import React from 'react';
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import { HiOutlineMail } from 'react-icons/hi';
import { BsFillPersonLinesFill } from 'react-icons/bs';
import Resume from '../assets/mapa_resume.pdf';

/**
 * Horizontal social + resume links (used in About — keeps the nav bar clean for clients).
 */
const SocialLinks = ({ className = '' }) => (
  <ul className={`flex flex-wrap items-center justify-center gap-3 sm:justify-start ${className}`}>
    <li>
      <a
        href='https://www.linkedin.com/in/johnedel-mapa-301805177/'
        target='_blank'
        rel='noopener noreferrer'
        className='inline-flex items-center gap-2 rounded-full bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-500 transition-colors'
        aria-label='LinkedIn'
      >
        <FaLinkedin size={18} />
        LinkedIn
      </a>
    </li>
    <li>
      <a
        href='https://github.com/johnedelmapa'
        target='_blank'
        rel='noopener noreferrer'
        className='inline-flex items-center gap-2 rounded-full bg-[#333333] px-4 py-2 text-sm font-medium text-white hover:bg-[#444] transition-colors'
        aria-label='GitHub'
      >
        <FaGithub size={18} />
        GitHub
      </a>
    </li>
    <li>
      <a
        href='mailto:mapajohnedel@gmail.com'
        className='inline-flex items-center gap-2 rounded-full bg-[#6fc2b0] px-4 py-2 text-sm font-medium text-gray-900 hover:opacity-90 transition-opacity'
        aria-label='Email'
      >
        <HiOutlineMail size={18} />
        Email
      </a>
    </li>
    <li>
      <a
        href={Resume}
        download='mapa_resume.pdf'
        className='inline-flex items-center gap-2 rounded-full bg-[#565f69] px-4 py-2 text-sm font-medium text-white hover:bg-[#666] transition-colors'
        aria-label='Download resume'
      >
        <BsFillPersonLinesFill size={18} />
        Resume
      </a>
    </li>
  </ul>
);

export default SocialLinks;
